var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("h1", { staticClass: "subtitle is-5" }, [
        _vm._v("Usuarios de la organización"),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-1" }, [_vm._v("Nuevo usuario")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("formulario", {
        attrs: { model: _vm.model, error: _vm.error, edit: false },
        on: { submit: _vm.submit },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v(
          "Ingrese los datos del nuevo usuario de la organización. Una vez que finalizó de cargar los datos, presione el botón "
        ),
        _c("span", { staticClass: "tag is-primary" }, [_vm._v("Guardar")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }